function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var resolveURL = require('resolve-url');

var _require = require('../../../package.json'),
    version = _require.version,
    dependencies = _require.dependencies;

var defaultOptions = require('../../constants/defaultOptions');
/*
 * Default options for browser worker
 */


module.exports = _objectSpread(_objectSpread({}, defaultOptions), {}, {
  workerPath: typeof process !== 'undefined' && process.env.FFMPEG_ENV === 'development' ? resolveURL("/dist/worker.dev.js?nocache=".concat(Math.random().toString(36).slice(3))) : "https://unpkg.com/@ffmpeg/ffmpeg@v".concat(version, "/dist/worker.min.js"),
  corePath: "https://unpkg.com/@ffmpeg/core@v".concat(dependencies['@ffmpeg/core'].substring(1), "/ffmpeg-core.js"),
  workerBlobURL: true
});